import "./RemittedRemittanceTransacitonsDataGridWithColumnToggledStyle.css";

import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReactSeverity,

	formatDateToShow,
	useNavigateToLogout,
} from "../../../../../common/Common";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { RequestParams, SplitButton } from "@websential/cosmic-v20";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { EnhancedButtonPrimeReact } from "../../../../EnhancedButtonPrimeReact";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HelpIcon from '@mui/icons-material/Help';
import { InputText } from "primereact/inputtext";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { MultiSelect } from "primereact/multiselect";

export interface IDataTable {
	rows: any;
	columns: any;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	showSettingColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	onDetailsTableRowEditClicked?: (params: any) => void;
	onDetailsTableRowDeleteClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	cardHeaderTitle?: string;
	cardHeaderSubTitle?: string;
	disabledHeaderTooltip?: boolean;
	viewIcon?: boolean;
	whiteSpace?: string;
	exportButton?: boolean;
	exportButtonLabel?: string;
	exportButtonInFileList?: boolean;
	// onExportButtonClick?: (event: string, params: any) => void;
	onExportButtonClick?: (event: string) => void;
	onExportButtonInFileListClick?: (event: string, params: any) => void;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	provinceOfEmployementDDL?: any;
	countryList?: any;
	provinceOrStateDDL?: any;
	onImportButtonClickedHandler?: () => void;
	onImportExcelButtonClickedHandler?: () => void;
	selectedRows: (value: any) => void
}

const RemittanceDetailsHeaderColumns = [
	{ field: "payPeriodType", headerName: "Pay Period Type", align: "left" },
	{ field: "endDate", headerName: "End Date", align: "center" },
	{ field: "paymentDate", headerName: "Payment Date", align: "center" },
	{ field: "amount", headerName: "Amount", align: "right" },
]

export const RemittedRemittanceTransacitonsDataGrid: React.FC<IDataTable> = ({
	rows,
	columns,
	showIndexColumn,
	showChecboxColumn,
	showSettingColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,
	whiteSpace,
	requestParamsToInitial,
	tableScrollHeight,
	onExportButtonClick,
	selectedRows,
	onDetailsTableRowDeleteClicked,
	onDetailsTableRowEditClicked
}) => {
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	// const [employeeListItems, setEmployeeListItems] = useState<any>(undefined);
	const [selectedItems, setSelectedItems] = useState<any>([]);

	// useEffect(() => {
	// 	if (rows && JSON.stringify(rows) !== JSON.stringify(employeeListItems)) {
	// 		setEmployeeListItems(rows);
	// 	}
	// }, [rows]);
	const [remittedRemittance, setRemittedRemittance] = useState<any>(
		rows && rows
	);

	// useEffect(() => {
	// 	RemittedRemittanceUpdatedData(remittedRemittance);
	// }, [remittedRemittance]);

	useEffect(() => {
		if (rows) {
			setRemittedRemittance(rows);
		}
	}, [rows]);

	const theme = useTheme();
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});


	const [selectedAuditEarningsItems, setSelectedAuditEarningsItems] =
		useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);

	const editColumn = (params: any) => {
		return (
			<>
				<EnhancedButtonPrimeReact
					icon={"pi pi-pencil"}
					onClickHandler={() => onRowEditClicked && onRowEditClicked(params)}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					className="p-button-rounded p-button-text w-2rem h-2rem"
					rounded
				/>
			</>
		);
	};

	const deleteRowColumn = (params: any) => {
		return (
			<EnhancedButtonPrimeReact
				icon="pi pi-times"
				onClickHandler={() => onRowDeleteClicked && onRowDeleteClicked(params)}
				severity={EnhancedButtonPrimeReactSeverity.Danger}
				className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
				rounded
			/>
		);
	};

	const [itemSearsch, setItemSearsch] = useState("");
	const onSearchButtonClicked = () => {
		setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};
	const handleClearSearch = () => {
		setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};

	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				{/* {showGlobalSearch && (
					<span
						className="p-input-icon-left w-3"
						style={{
							display: "flex",
							marginLeft: "10px",
							height: "37px",
							maxWidth: "250px",
						}}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className="w-full"
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding: "10px 22px 10px 10px",

								// borderRadius: "0px 2px 2px 0px",
								// fontSize: ".875rem",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								borderRadius: "0px 2px 2px 0px",
								fontSize: ".875rem",
							}}
						>
							Search
						</Button>
					</span>
				)} */}
				<span></span>

				{rows && rows.length > 0 ? (
					<EnhancedButtonPrimeReact
						// icon="pi pi-trash"
						label="Add Error Message"
						raised
						// onClickHandler={onAddErrorMessageButtonClickedHandler}
						style={{ marginRight: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
				) : (
					<></>
				)}
				{selectionToolbar && selectionToolbar(selectedItems)}
			</div>
		);
	};
	const headerSearch = renderHeader();
	function search(_row: any) {
		return (
			rows &&
			rows.filter(
				(rows: any) =>
					rows.clientName.props.children
						.toLowerCase()
						.indexOf(itemSearsch.toLowerCase()) > -1
			)
		);
	}

	const onPage = (event: any) => {
		setLoading(true);

		setTimeout(() => {
			setRequestParams({
				...event,
				searchQuery: itemSearch,
			});
			setLoading(false);
		}, 1000);
	};
	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}

			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			setTimeout(() => {
				setLoading(false);
			}, 1000);
		},
		[sortOrder, sortField]
	);

	useEffect(() => {
		if (onRequestParamsChange) {
			if (isInitialRequest.current === true) {
				isInitialRequest.current = false;
			} else {
				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});
		}
	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);

			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			selectedRows(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);

			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);
				}
			}
		},
		[rows, selectedRowsValues, selectedItems]
	);

	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		setRemittedRemittance((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};
	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		if (field.field === "date") {
			if (
				rowData.employeeStatus !== "" &&
				rowData.employeeStatus !== undefined &&
				rowData.employeeStatus !== null
			) {
				if (rowData.date === null) {
					return "p-component p-filled calender-error-input";
				} else if (rowData.date === "") {
					return "p-component p-filled calender-error-input";
				}
			}
		} else {
			return "p-component p-filled input-dropdown-fields";
		}
	};

	const setting = () => {
		return (
			<div>
				<i className="pi pi-cog text-xl"></i>
			</div>
		);
	};

	const settingBody = (params: any) => {

		return (
			<>
				<EnhancedButtonPrimeReact
					icon={"pi pi-user-edit"}
					onClickHandler={() =>
						onDetailsTableRowEditClicked && onDetailsTableRowEditClicked(params)
					}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					className="p-button-rounded p-button-text w-2rem h-2rem"
					rounded
				/>
				<EnhancedButtonPrimeReact
					icon="pi pi-times"
					onClickHandler={() =>
						onDetailsTableRowEditClicked && onDetailsTableRowEditClicked(params)
					}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
					rounded
				/>
			</>
		);
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		const [openTooltip, setOpenTooltip] = useState(false);

		const handleToggle = () => {
			setOpenTooltip((prev) => !prev);
		};

		if (x.field === 'deductionDate') {
			return (
				<Calendar
					id="deductionDate"
					value={rowData[x.field]}
					showIcon
					className="calender"
					style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					showButtonBar
				/>
			)
		} else if (x.field === 'notes') {
			return (
				<InputText
					value={rowData[x.field]}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					style={{ height: "2.6rem", margin: "4px 0px 4px 0px", width: "auto" }}
				/>
			)
		} else if (x.field === 'details') {
			return (
				<DataTable
					value={
						rows &&
						rowData[x.field]
					}
					lazy
					dataKey="id"
					emptyMessage={
						rows && rows.length === 0 ? "No Record Found." : "Loading..."
					}
					className="RemittanceDetailDataGrid"
				>
					{RemittanceDetailsHeaderColumns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									align={x.align}
									style={{
										minWidth: x.minWidth,
										fontSize: "0.875rem",
									}}
								// body={(rowData: any, row: any) =>
								// 	detailColumnsBody(rowData, row, x)
								// }
								/>
							);
						})}
					{rowData[x.field] && rowData[x.field].length ? (
						<Column
							body={settingBody}
							header={setting}
							alignHeader={"center"}
						></Column>
					) : undefined}
				</DataTable>
			)
		} else {
			return (
				<Typography sx={{ fontSize: ".875rem" }}>
					{rowData[x.field]}
				</Typography>
			)
		}
	};


	useEffect(() => {
		// Check for deleted items and remove them from selectedItems
		const updatedSelectedItems =
			selectedItems &&
			selectedItems.length > 0 &&
			selectedItems.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
		// Only update if there are changes to selectedItems
		if (
			updatedSelectedItems &&
			updatedSelectedItems.length !== selectedItems.length
		) {
			setSelectedItems(updatedSelectedItems);
			selectedRows(updatedSelectedItems);

			const updatedSelectedItemsIds = updatedSelectedItems.map(
				(item: any) => item.id
			);
			// Update selectedItemsIds
			setSelectedItemsIds(updatedSelectedItemsIds);
		}
		// const updatedSelectedSubItems = selectedSubItems.filter(
		// 	(item: any) => !selectedItemsIds.includes(item.parentId)
		// );
		// if (
		// 	updatedSelectedSubItems &&
		// 	updatedSelectedSubItems.length !== selectedSubItems.length
		// ) {
		// 	setSelectedSubItems(updatedSelectedSubItems)
		// 	selectedSubRows(updatedSelectedSubItems)
		// }

	}, [rows, selectedItems, selectedItemsIds]);

	const onCopyIconClickedHandler = (name: string, dateOrNotes: string | null) => {
	
		if (dateOrNotes && dateOrNotes !== null && dateOrNotes !== "") {
			if (name === "Deduction Date") {
				const updatedRemittedRemittance = remittedRemittance && remittedRemittance.map((item: any) => ({
					...item,
					deductionDate: dateOrNotes
				}))
			
				setRemittedRemittance(updatedRemittedRemittance)


				// abi k liye agr wo 3 row may add krta to sab may add ho jata 
				// agr bad may sir ny kaha k just usk nichy wali rows py hona 
				// then use this 

				// const firstValidIndex = remittedRemittance && remittedRemittance.findIndex(
				// 	(item: any) => item.deductionDate && item.deductionDate
				// );
				// const fromFirstValidToEnd = firstValidIndex !== -1
				// 	? remittedRemittance && remittedRemittance.slice(firstValidIndex)
				// 	: [];

				// const fromStartToBeforeFirstValid =
				// 	firstValidIndex !== -1 ? remittedRemittance && remittedRemittance.slice(0, firstValidIndex) : [];

				// const updatedFromFirstValidToEnd = fromFirstValidToEnd.map((item: any) => ({
				// 	...item,
				// 	deductionDate: dateOrNotes
				// }))
				// const result = [...fromStartToBeforeFirstValid, ...updatedFromFirstValidToEnd]
		
				// setRemittedRemittance(result)
			} else {
				const updatedRemittedRemittance = remittedRemittance && remittedRemittance.map((item: any) => ({
					...item,
					notes: dateOrNotes
				}))
			
				setRemittedRemittance(updatedRemittedRemittance)
			}
		} else {
			// alert(dateOrNotes)
		}
	}
	const onDeleteIconClickedHandler = (name: string) => {
		if (name === "Deduction Date") {
			const updatedRemittedRemittance = remittedRemittance && remittedRemittance.map((item: any) => ({
				...item,
				deductionDate: null
			}))
			
			setRemittedRemittance(updatedRemittedRemittance)
		} else {
			const updatedRemittedRemittance = remittedRemittance && remittedRemittance.map((item: any) => ({
				...item,
				notes: null
			}))
		
			setRemittedRemittance(updatedRemittedRemittance)
		}
	}

	const generateHeaderName = (name: string) => {
		return (
			<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<Typography sx={{ fontSize: ".9rem", fontWeight: "bold" }}>{name}</Typography>
				<Box>
					<EnhancedButtonPrimeReact
						icon={"pi pi-copy"}
						// onClickHandler={() => onColumnCopyButtonClicked()}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						className="p-button-rounded p-button-text w-2rem h-2rem"
						rounded
						onClickHandler={() => onCopyIconClickedHandler(name, name === 'Deduction Date' ? remittedRemittance && remittedRemittance.length > 0 && remittedRemittance.find((item: any) => item.deductionDate)?.deductionDate : remittedRemittance?.find((item: any) => item.notes)?.notes)}
					/>
					<EnhancedButtonPrimeReact
						icon={"pi pi-trash"}
						// onClickHandler={() => onColumnDeleteIconClicked()}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						className="p-button-rounded p-button-text w-2rem h-2rem"
						rounded
						onClickHandler={() => onDeleteIconClickedHandler(name)}
					/>
				</Box>
			</Box>
		);
	};
	const updatedHeaderColumns = columns && columns.map((items: any) => {
		return {
			...items,
			headerName: items.field === "deductionDate" ? generateHeaderName(items.headerName) : items.field === "notes" ? generateHeaderName(items.headerName) : items.headerName
		}
	})



	return (
		<>
			<DataTable
				value={
					rows &&
					remittedRemittance &&
					remittedRemittance
				}
				responsiveLayout="scroll"
				lazy
				dataKey="id"
				paginator
				first={requestParams.first}
				rows={requestParams.rows}
				totalRecords={totalRecords}
				onPage={onPage}
				rowsPerPageOptions={rowsPerPageOptions}
				paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
				currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
				selection={selectedItems}
				onSelectionChange={onSelectionModelChange}
				key={selectedItems}
				editMode=""
				selectionMode={"checkbox"}
				showGridlines
				resizableColumns
				columnResizeMode="expand"
				scrollable
				scrollHeight={tableScrollHeight ? "75vh" : ""}
				// // reorderableColumns
				// onColReorder={onColReorder}
				loading={isLoading ? isLoading : loading}
				// header={headerSearch}
				footer={footer ? footer : undefined}
				emptyMessage={
					rows && rows.length === 0 ? "No Record Found." : "Loading..."
				}
				className="RemittedRemittanceTransacitonsDataGridWithColumnToggled"
				// style={{
				// 	margin: `${tableMargin ? tableMargin : "16px 0 0.5rem 0"}`,
				// }}
				sortMode="single"
				onSort={onSort}
			>
				{columns && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						frozen
						resizeable={false}
						style={{ width: "36px", textAlign: "center" }}
						field="selection"
						alignFrozen="left"
						columnKey="selection"
						className="selectionHeader"
						headerClassName="selectionHeader"
					></Column>
				)}
				{rows && rows.length ? (
					<Column
						header="#"
						className="indexColumn"
						headerClassName="indexColumn"
						headerStyle={{ width: "24px" }}
						frozen
						hidden={!showIndexColumn}
						body={(data, options) => options.rowIndex + 1}
					></Column>
				) : undefined}

				{columns &&
					updatedHeaderColumns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									hidden={x.hide}
									// sortable={x.sortable}
									// resizeable={x.resizable}
									dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									reorderable={x.disableReorder}
									exportable={x.disableExport}
									frozen={x.frozenColumn}
									alignFrozen={x.alignFrozen}
									columnKey={x.field}
									style={{
										minWidth: x.minWidth,
										fontSize: "0.875rem",
									}}
									headerStyle={{ whiteSpace: whiteSpace ? whiteSpace : "nowrap" }}
									footer={x.footer}
									body={(rowData: any, row: any) =>
										columnsBody(rowData, row, x)
									}
									headerClassName={x.field === "deductionDate" ? "actions-header" : x.field === "notes" ? "actions-header" : ""}
								/>
							);
						})}
			</DataTable>
		</>
	);
};
